import { QuestionConnection } from "@/components/features/items/edit/_shared/ui/components/main/questions/connection";

import { useDummyRoomPlanConnection } from "./hooks/use-plan-connection";

export const QuestionDummyRoomPlanConnection = () => {
	const {
		availableItemIDs,
		nameAndIDOptions,
		onSetAvailableItemIDs,
		rawAvailableItemIDs, //
	} = useDummyRoomPlanConnection();

	const title = "利用可能なプラン";

	return (
		<QuestionConnection
			title={title}
			availableItemIDs={availableItemIDs}
			nameAndIDOptions={nameAndIDOptions}
			onSetAvailableItemIDs={onSetAvailableItemIDs}
			rawAvailableItemIDs={rawAvailableItemIDs}
		/>
	);
};

QuestionDummyRoomPlanConnection.displayName = "QuestionDummyRoomPlanConnection";
